import { FormEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { LoadingSpinner } from '../../components/ui/LoadingSpinner';
import { PageCard } from '../../components/layout/page/PageCard';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { fetchCompanySettings, updateCompanySettings } from '../../services/platformApi';
import { CompanySetting } from '../../types/CompanySetting';

export function CompanySettingsPage() {
  const [settings, setSettings] = useState<CompanySetting | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function load() {
      try {
        setSettings(await fetchCompanySettings());
      } finally {
        setLoading(false);
      }
    }

    void load();
  }, []);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!settings) {
      return;
    }

    setSaving(true);
    try {
      const updated = await updateCompanySettings({
        language: settings.language,
        appTitle: settings.appTitle ?? undefined,
        primaryColor: settings.primaryColor ?? undefined,
        secondaryColor: settings.secondaryColor ?? undefined,
        timezone: settings.timezone ?? undefined,
        dateFormat: settings.dateFormat ?? undefined,
      });
      setSettings(updated);
      toast.success('Configurações da empresa salvas.');
    } catch {
      toast.error('Não foi possível salvar as configurações.');
    } finally {
      setSaving(false);
    }
  }

  if (loading || !settings) {
    return <LoadingSpinner />;
  }

  return (
    <PageShell variant="form">
      <PageHeader title="Empresa" description="Branding e preferências da organização." />

      <form onSubmit={(e) => void handleSubmit(e)} className="erp-form">
        <PageCard>
          <label className="erp-label">
            Título do app
            <input
              value={settings.appTitle ?? ''}
              onChange={(e) => setSettings({ ...settings, appTitle: e.target.value })}
              className="erp-input"
              placeholder="Baruk Go"
            />
          </label>
          <label className="erp-label">
            Idioma
            <input
              value={settings.language}
              onChange={(e) => setSettings({ ...settings, language: e.target.value })}
              className="erp-input"
            />
          </label>
          <div className="erp-form-grid">
            <label className="erp-label">
              Cor primária
              <input
                value={settings.primaryColor ?? ''}
                onChange={(e) => setSettings({ ...settings, primaryColor: e.target.value })}
                className="erp-input"
                placeholder="#1F669D"
              />
            </label>
            <label className="erp-label">
              Cor secundária
              <input
                value={settings.secondaryColor ?? ''}
                onChange={(e) => setSettings({ ...settings, secondaryColor: e.target.value })}
                className="erp-input"
              />
            </label>
          </div>
          <div className="erp-btn-actions">
            <button type="submit" disabled={saving} className="erp-btn-primary">
              {saving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </PageCard>
      </form>
    </PageShell>
  );
}
